import React from 'react';
import classNames from './style.module.scss';

interface TutorialCardProps {
	title: string;
	body: string;
	onWatchTutorial: () => void;
}

const TutorialCard: React.FC<TutorialCardProps> = (props) => {
	return (
		<div className={classNames.tutorialCard}>
			<div className={classNames.tutorialCardIcon}>
				<img
					src="https://placehold.co/600x400/235681/d1e7f9/png?text=Tutorial"
					alt="Placeholder"
					loading="lazy"
				/>
			</div>
			<div className={classNames.tutorialCardDetails}>
				<div className={classNames.tutorialCardDetailsTitle}>{props.title}</div>
				<div className={classNames.tutorialCardDetailsBody}>{props.body}</div>

				<button onClick={props.onWatchTutorial}>Watch Tutorial</button>
			</div>
		</div>
	);
};

export default TutorialCard;
